export function buildAuth0TokenParams({ audience }) {
  if (!audience) return undefined;

  return {
    authorizationParams: {
      audience,
    },
  };
}
